export const selectPopperOptions = {
  placement: 'bottom-start' as const,
  strategy: 'fixed' as const,
  modifiers: [
    { name: 'preventOverflow', options: { boundary: 'viewport', padding: 8 } },
    { name: 'flip', options: { fallbackPlacements: ['top-start', 'bottom-start', 'bottom', 'top'] } },
  ],
};
